import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptLink
 */
export const receiptLinkStyles = ({ theme }) => css `
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing[200])};
	margin: 0;
	text-decoration: none;
`;
export const StyledReceiptLink = styled(Typography).attrs({
    variant: 'link-text',
}) `
	${receiptLinkStyles}
`;
/**
 * ReceiptLink label
 */
export const receiptLinkLabelStyles = () => css `
	text-decoration: underline;
`;
export const StyledReceiptLinkLabel = styled.span `
	${receiptLinkLabelStyles}
`;
